import { network } from 'services/network';

export const extractResourceChartBarToCsv = (params) => {
    return network.post('api/bo/extractResourceChartBarToCsv', params).then((response) => {
        const blob = new Blob([response.data], {
            type: 'text/plain',
        });
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = `${params.fileName}.csv`;
        a.click();

        return true;
    });
};
